import React from 'react'
import { Tooltip} from 'antd'
import { rightTickIcon, crossRedIcon, crossGreyIcon } from '../../assets/images'

const networkSchema = ({ data, headers }) => {
    return (
        <tr className='text-gray-600' >
            {headers.map((key, index) => {
                switch (key.toUpperCase()) {
                    case 'ENTERPRISES NAME':
                        return <td className='pl-3 pr-5 py-5'>{data?.name}</td>
                    case 'BRANCH NAME':
                        return <td className='pl-3 pr-5 py-5'>{data?.branch}</td>
                    case 'OUTSOURCED FACILITIES':
                        return <td className='pl-3 pr-5 py-5'>{data?.outsource_facilities}</td>
                    case 'CITY':
                        return <td className='pl-3 pr-5 py-5'>{data?.city}</td>
                    case key.toUpperCase():
                        return (
                            <td className='pl-3 pr-5 py-5'>
                                <Tooltip
                                    overlayClassName=''
                                    title={
                                        data?.mapping[index - 4]?.supported === "Yes"
                                        ? "All services are available at this center"
                                        : data?.mapping[index - 4]?.supported === "No"
                                        ? 'Enterprise ID not matched'
                                        : data?.mapping[index - 4]?.full_missing === false
                                        ? `Following services are not available at this center ${data?.mapping[index - 4]?.reason}`
                                        : 'Services are not available at this center'
                                    }
                                    trigger='hover'
                                    >
                                    <span>
                                        {data?.mapping[index - 4]?.supported === "Yes" ? (
                                        <img src={rightTickIcon} />
                                        ) : data?.mapping[index - 4]?.full_missing === false ? (
                                        <img src={crossGreyIcon} />
                                        ) : (
                                        <img src={crossRedIcon} />
                                        )}
                                    </span>
                                </Tooltip>

                            </td>
                        )
                }
            })}
        </tr>
    )
}

export default networkSchema